module.exports = __webpack_public_path__ + "img/payment_methods.84507628.svg";